import { Pagination } from 'antd';
import styled from 'styled-components';

export const PaginationComponentStyle = styled(Pagination)`
  &.ant-pagination {
    display: flex;
    justify-content: end;
    margin-top: 20px;

    .ant-pagination-item {
      &:hover {
        border-color: #0c3255;

        a {
          color: #0c3255;
        }
      }
    }

    .ant-pagination-item:hover .ant-pagination-item-link,
    .ant-pagination-prev:hover .ant-pagination-item-link,
    .ant-pagination-next:hover .ant-pagination-item-link {
      border-color: #0c3255;
      color: #0c3255;
    }

    .ant-pagination-disabled .ant-pagination-item-link,
    .ant-pagination-disabled:hover .ant-pagination-item-link {
      color: rgba(0, 0, 0, 0.25);
      border-color: #d9d9d9;
      cursor: not-allowed;
    }

    .ant-pagination-item-active,
    .ant-pagination-item-active a {
      color: #ffffff !important;
      background-color: #0c3255;
      border-color: #0c3255;
    }
  }
`;
